module.exports = __webpack_public_path__ + "img/developed-with-youtube-lowercase-light-low.2fc387e1.png";